<mat-card-header class="">
  <div class="row col-md-12">
    <div class="col-6">
      @if (viewMode === 'edit' || viewMode === 'read') {
        <div class="titre-modale">
          Détails - <span>({{ firstName }} {{ lastname }})</span>
        </div>
      }
    </div>
    <div class="col-md-6 text-end mb-2 mr-0 ml-auto gx-0">
      <button (click)="onBackToAgentList()" class="py-0" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="col-6" style="position: absolute">
      @if (viewMode === 'user') {
        <div class="titre-modale">
          Gérer mes délégations <span>({{ userName }})</span>
        </div>
      }
    </div>
  </div>
</mat-card-header>
<mat-dialog-content class="mat-typography">
  <mat-divider class="my-3"></mat-divider>

  <div class="div-contenu">
    <div class="row mt-3">
      <!-- <div class="col">
      <mat-form-field class="mr-5">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="appDataTable.applyFilter($event)" #input />
      </mat-form-field>
    </div> -->
      <div class="col flex-container end align-items-center">
        <div>
          @if (viewMode === 'edit' || viewMode === 'user') {
            <button (click)="openCreateAgentDelegation()" mat-raised-button class="bt-table-defaut bt-table-ajouter mr-5">
              <mat-icon>add</mat-icon> Ajouter une délégation
            </button>
          }
        </div>
      </div>
    </div>

    @if (viewMode === 'edit') {
      <div class="mt-1">
        <app-data-table
          #appDataTable
          [displayedColumns]="displayedColumns"
          [cellStyleCss]="cellStyleCss"
          [data]="delegationList"
          [expendable]="false"
          [hasView]="false"
          [editable]="true"
          [delatable]="true"
          [filter]="false"
          [length]="lenght"
          (deleteElement)="deleteDelegue($event, false)"
          (clicModalModifier)="modifyDelegate($event)"
          (updatePagination)="updatePagination($event)"
          (updateFiltre)="updateFiltre($event)"
          [customFilter]="true"
        ></app-data-table>
      </div>
    }

    @if (viewMode === 'user') {
      <div class="mt-1">
        <app-data-table
          #appDataTable
          [displayedColumns]="displayedUserColumns"
          [cellStyleCss]="cellStyleCss"
          [data]="delegationList"
          [expendable]="false"
          [hasView]="false"
          [editable]="true"
          [delatable]="true"
          [filter]="false"
          [length]="lenght"
          (clicModalModifier)="modifyDelegate($event)"
          (deleteElement)="deleteDelegue($event, true)"
          (updatePagination)="updatePagination($event)"
          (updateFiltre)="updateFiltre($event)"
          [customFilter]="true"
        ></app-data-table>
      </div>
    }
    @if (viewMode === 'read') {
      <div class="mt-1">
        <mat-tab-group (selectedTabChange)="onTabChanged($event)">
          <mat-tab style="overflow-x: hidden" label="DÉLÉGATIONS">
            <ng-template matTabContent>
              <div class="row mt-3">
                <div class="col"></div>
              </div>
              <app-data-table
                #appDataTable
                [displayedColumns]="displayedViewColumns"
                [cellStyleCss]="cellStyleCss"
                [data]="delegationList"
                [expendable]="false"
                [hasView]="false"
                [editable]="false"
                [delatable]="false"
                [filter]="false"
                (deleteElement)="deleteDelegue($event, false)"
                [length]="lenght"
                (updatePagination)="updatePagination($event)"
                (updateFiltre)="updateFiltre($event)"
                [customFilter]="false"
              ></app-data-table>
            </ng-template>
          </mat-tab>

          <mat-tab label="AUTRES INFORMATIONS DE L'AGENT">
            <ng-template matTabContent>
              <div class="mt-4">
                <fieldset class="informations-container">
                  <legend class="informations-title">Informations</legend>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Directeur :</span>
                      <span class="info-value">{{ agentData?.flagANotifier ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">DGS :</span>
                      <span class="info-value">{{ agentData?.flagDG ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Responsable de service :</span>
                      <span class="info-value">{{ agentData?.flagResponsable ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Code poste :</span>
                      <span class="info-value">{{ agentData?.codePoste || '' }}</span>
                    </div>
                  </div>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Destinataire RH :</span>
                      <span class="info-value">{{ agentData?.flagRH ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Destinataire GPEEC :</span>
                      <span class="info-value">{{ agentData?.flagGpeec ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Destinataire Statutaire :</span>
                      <span class="info-value">{{ agentData?.flagGestionnaireStatutaire ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">SNF date début :</span>
                      <span class="info-value">{{ agentData?.snfDateDebut | date: 'dd/MM/yyyy' }}</span>
                    </div>
                  </div>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">SNF date fin :</span>
                      <span class="info-value">{{ agentData?.snfDateFin | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nb SNF :</span>
                      <span class="info-value">{{ agentData?.snfNb || '' }}</span>
                    </div>
                    <div class="info-item"></div>
                  </div>

                  <mat-divider class="info-divider"></mat-divider>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Cdisation :</span>
                      <span class="info-value">{{ agentData?.flagCdisation ? 'Oui' : 'Non' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Date cdisation :</span>
                      <span class="info-value">{{ agentData?.cdisationDate | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nb jours restants pour cdisation :</span>
                      <span class="info-value">{{ agentData?.cdisationJoursRestants || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Date démarrage pour cdisation :</span>
                      <span class="info-value">{{ agentData?.cdisationDateDemarrage | date: 'dd/MM/yyyy' }}</span>
                    </div>
                  </div>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Abs date début :</span>
                      <span class="info-value">{{ agentData?.absenceDateDebut | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Abs date fin :</span>
                      <span class="info-value">{{ agentData?.absenceDateFin | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nb MO :</span>
                      <span class="info-value">{{ agentData?.absenceMoNb || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nb AT/MP :</span>
                      <span class="info-value">{{ agentData?.absenceAtmpNb || '' }}</span>
                    </div>
                  </div>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Nb MD/ML :</span>
                      <span class="info-value">{{ agentData?.absenceMdmlNb || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nb MA/PA :</span>
                      <span class="info-value">{{ agentData?.absenceMapaNb || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nb Abs total :</span>
                      <span class="info-value">{{ agentData?.absenceTotal || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Structure :</span>
                      <span class="info-value">{{ agentData?.libelleStructure || '' }}</span>
                    </div>
                  </div>

                  <mat-divider class="info-divider"></mat-divider>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Date expiration carte séjour :</span>
                      <span class="info-value">{{ agentData?.dateExpirationCS | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Agt remplacé :</span>
                      <span class="info-value">{{ agentData?.agentRemplaceNom || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Code engagement :</span>
                      <span class="info-value">{{ agentData?.codeEngagement || '' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Maxi FC :</span>
                      <span class="info-value">{{ agentData?.dateRetourDirection | date: 'dd/MM/yyyy' }}</span>
                    </div>
                  </div>

                  <div class="info-row">
                    <div class="info-item">
                      <span class="info-label">Date de naissance :</span>
                      <span class="info-value">{{ agentData?.dateNaissance | date: 'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Visibilité sur toute sa direction :</span>
                      <span class="info-value">{{ agentData?.flagVisibiliteDirection ? 'Oui' : 'Non' }}</span>
                    </div>
                  </div>
                </fieldset>
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    }
  </div>
</mat-dialog-content>
